import { Card, CardBody, Col, Row } from "reactstrap";
import { ProgressBar } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { MultipleBarsTitle } from "../../../Constants/Constants";
import { MultipleBarData, MultipleBarsSubTitle } from "../../../Data/UiKits/Progress";

const MultipleBars = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={MultipleBarsTitle} span={MultipleBarsSubTitle} />
        <CardBody className="progress-showcase">
          <Row>
            <Col>
              {MultipleBarData &&
                MultipleBarData.map((item, index) => (
                  <ProgressBar key={index} multi>
                    {item.data && item.data.map((item, index) => <ProgressBar key={index} value={item.value} color={item.class} bar />)}
                  </ProgressBar>
                ))}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default MultipleBars